import React from 'react';
import { Stack } from '@mui/material';
import EdgeTypeSelector from '../EdgeTypeSelector';
import EdgeActionButtons from '../EdgeActionButtons';
import { LandingEdgeTypes } from '../../context/DeckContext';
import EdgeType from '../../../../../../enums/edgeType';
import { Block, Edge } from '../../../../../../types/shared/blocks';

interface LandingEdgePopperProps {
	block: Block;
	blockEdge: Edge;
	inputEdge: EdgeType | undefined;
	setInputEdge: (edgeType: EdgeType) => void;
	onAddStair: () => void;
	onDropdownOpenChange?: (open: boolean) => void;
}

const LandingEdgePopper: React.FC<LandingEdgePopperProps> = ({
	blockEdge,
	inputEdge,
	setInputEdge,
	onAddStair,
	onDropdownOpenChange,
}) => {
	const isEdgeDisabled = blockEdge?.type === EdgeType.BLOCK_ATTACHED;

	return (
		<Stack spacing={1.25}>
			<EdgeTypeSelector
				edgeTypes={LandingEdgeTypes}
				value={inputEdge}
				onChange={setInputEdge}
				disabled={isEdgeDisabled}
				label="Edge Types"
				onDropdownOpenChange={onDropdownOpenChange}
			/>

			<EdgeActionButtons showAddStair={true} onAddStair={onAddStair} />
		</Stack>
	);
};

export default LandingEdgePopper;
